import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, useTheme } from '@uds/theme-utils';
import { useBreakpoints } from '@ux/responsive';

export default () => {
  const breakpoints = useBreakpoints();
  const { theme } = useTheme();
  const { isMinLg } = breakpoints;
  const { spacing } = theme;

  return useStyles(
    {
      default: {
        row: {
          ...cssSides('margin', Side.X, gu2px(-0.5, spacing)),
          ...cssSides('margin', Side.Y, gu2px(-1.5, spacing)),
        },
        item: {
          ...cssSides('padding', Side.X, gu2px(0.5, spacing)),
          ...cssSides('padding', Side.Y, gu2px(1.5, spacing)),
        },
      },
      isMinLg: {
        row: {
          ...cssSides('margin', Side.X, gu2px(-1, spacing)),
          ...cssSides('margin', Side.Y, gu2px(-2, spacing)),
        },
        item: {
          ...cssSides('padding', Side.X, gu2px(1, spacing)),
          ...cssSides('padding', Side.Y, gu2px(2, spacing)),
        },
      },
    },
    [{ isMinLg }],
  );
};
